/**
 * Explore's applied filters as removable chips, plus Clear All. A chosen
 * Date Interval shows as a chip too; removing it returns to Automatic.
 */

import type { ReactNode } from 'react';

import type { Filter } from '../../reports/reports-api.ts';
import { DATE_INTERVALS, type DateInterval } from './ga4-views.ts';

export function FilterChips(props: {
  filters: Filter[];
  dimensionLabel: (key: string) => string;
  onFilters: (filters: Filter[]) => void;
  interval: DateInterval;
  onInterval: (interval: DateInterval) => void;
}): ReactNode {
  const hasInterval = props.interval !== 'auto';
  if (props.filters.length === 0 && !hasInterval) return null;
  const intervalLabel = DATE_INTERVALS.find((item) => item.key === props.interval)?.label;
  return (
    <div className="ex-chips" aria-label="Applied filters">
      {props.filters.map((filter) => (
        <span key={filter.dimension} className="ex-chip">
          {props.dimensionLabel(filter.dimension)} is {filter.values.join(', ')}
          <button
            type="button"
            aria-label={`Remove ${props.dimensionLabel(filter.dimension)} filter`}
            onClick={() => props.onFilters(props.filters.filter((item) => item !== filter))}
          >
            ×
          </button>
        </span>
      ))}
      {hasInterval && (
        <span className="ex-chip">
          Date Interval is {intervalLabel}
          <button
            type="button"
            aria-label="Remove Date Interval filter"
            onClick={() => props.onInterval('auto')}
          >
            ×
          </button>
        </span>
      )}
      <button
        type="button"
        className="ex-link"
        onClick={() => {
          props.onFilters([]);
          props.onInterval('auto');
        }}
      >
        Clear All
      </button>
    </div>
  );
}
